import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useI18n } from "../context/I18nContext";
import { errMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { ArrowLeft, Mail } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-background" data-testid="forgot-page">
      <div className="w-full max-w-sm border p-8">
        <div className="flex items-center gap-2 text-primary mb-4">
          <Mail size={16} />
          <span className="text-[10px] font-bold uppercase tracking-widest">MFIS Supply-Chain</span>
        </div>
        <h1 className="text-2xl font-black tracking-tighter mb-1">{t("fp.title")}</h1>
        <p className="text-xs text-muted-foreground mb-6">{t("fp.subtitle")}</p>
        {sent ? (
          <div className="text-sm border border-primary/40 bg-primary/5 p-3 mb-4" data-testid="fp-sent-message">
            {t("fp.sent")}
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="fp-email" className="text-xs font-bold uppercase tracking-widest">{t("fp.email")}</Label>
              <Input id="fp-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="fp-email-input" className="rounded-none" />
            </div>
            {error && <div className="text-xs text-destructive border border-destructive/40 bg-destructive/5 p-2">{error}</div>}
            <Button type="submit" disabled={busy} data-testid="fp-submit-button"
              className="w-full rounded-none font-bold uppercase tracking-widest">
              {t("fp.submit")}
            </Button>
          </form>
        )}
        <Link to="/login" className="inline-flex items-center gap-1 mt-6 text-[11px] font-bold uppercase tracking-widest text-muted-foreground hover:text-primary" data-testid="fp-back-link">
          <ArrowLeft size={12} /> {t("fp.back")}
        </Link>
      </div>
    </div>
  );
}
